import { combineReducers } from "@reduxjs/toolkit";
import {
  addCourseToCartReducer,
  getCartReducer,
  deleteItemFromCartReducer,
  addOrderReducer,
  handleCartReducer,
  getDetailOrderReducer,
} from "./slices";

const ordersReducer = combineReducers({
  allCart: getCartReducer,
  addCourseToCart: addCourseToCartReducer,
  deleteItemFromCart: deleteItemFromCartReducer,
  cart: handleCartReducer,
  addOrder: addOrderReducer,
  detailOrder: getDetailOrderReducer,
});

export default ordersReducer;
